import text from './text.json'
import TextHelper from './../../../utils/text'
import DateHelper from '../../../utils/date'
import {useSelector} from 'react-redux'
import {CheckIcon, HelpIcon} from '../../../icons'
import {locationManager} from '../../../utils/locations'
import Tooltip from '../../core/tooltip'
import Table from './../../core/table'
import {routes} from '../../../routes'
import LimitManager from '../../../utils/limitManager'
import {colors} from '../../../utils/colors'

const LogsTable = () => {
    const data = useSelector(state => state.monitoring.resourceLogs)
    const tableHeader = [
        {label: 'Date', className: 'min-width'},
        {label: 'Status', className: 'min-width'},
        {label: 'Change', className: 'log-change-header'},
        {label: 'Location', className: 'min-width'},
        {label: 'Duration', className: 'min-width'}
    ]

    const tbodyData = []

    const generateConvertedDate = time => {
        const date = new Date(Date.parse(time))

        return (
            <span className="min-width date">
                <span
                    className="checked-at">{[DateHelper.addZero(date.getHours()), DateHelper.addZero(date.getMinutes())].join(':')}</span>
                <span>{[date.getFullYear(), DateHelper.addZero(date.getMonth() + 1), DateHelper.addZero(date.getDate())].join('.')}</span>
            </span>
        )
    }

    const generateLogChange = state => {
        return (
            <span className="log-change-header log-change">
                <span className="log-text">{text.change_message}</span>
                <span
                    className={`${TextHelper.getResourceState(state, ['down', 'up'])} up-down`}>{TextHelper.getResourceState(state, [text.down, text.up])}</span>
                <span>{text.to}</span>
                <span
                    className={`${TextHelper.getResourceState(state, ['up', 'down'])} up-down`}>{TextHelper.getResourceState(state, [text.up, text.down])}</span>
            </span>
        )
    }

    const generateLogDuration = duration => {
        let message = ''
        const elements = DateHelper.timeFormatter(duration)
        duration === 0 ? message = text.not_available
            : duration < 60 ? message = duration + ' ' + elements.minuteText
                : message = elements.hours + ' ' + elements.hourText + ' ' + elements.minutes + ' ' + elements.minuteText
        return <span className="min-width duration">{message}</span>
    }
    const generateLogDescription = description => {
        return !LimitManager.getStateDescIsEnabled() ?
            `<span>${description}</span><a href=${routes.plans.path}>${text.upgrade_plan}</a>` :
            `<span>${description}</span>`
    }

    const generateLogStatus = log => {
        return (
            <div className="min-width log-status">
                <span>
                    {log?.status}
                </span>
                {log?.description &&
                    <span>
                        <Tooltip
                            trigger="click"
                            content={<span dangerouslySetInnerHTML={{__html: generateLogDescription(log?.description)}}/>}
                            interactive={true}
                        >
                            <HelpIcon stroke={colors.colorMuted} width="16" height="16"/>
                        </Tooltip>
                    </span>}
            </div>
        )
    }

    const getRegions = log => {
        let approvalRegion = log.approval_region ?

            <Tooltip content={locationManager.allLocations[log.approval_region]?.location}>
                {locationManager.allLocations[log.approval_region]?.icon}
            </Tooltip> : null
        return (
            <span className="min-width">
                <div className="region-container">
                    <Tooltip content={locationManager.allLocations[log.region]?.location}>
                        {locationManager.allLocations[log.region]?.icon}
                    </Tooltip>
                    {approvalRegion}
                    {approvalRegion && (
                        <span className="approval-region-info">
                            <Tooltip content={text.down_time_approved}>
                                <CheckIcon className="warning-icon tooltip-target"/>
                            </Tooltip>
                        </span>
                    )}
                </div>
            </span>
        )
    }

    data?.map(log => {
        tbodyData.push([
            generateConvertedDate(log.checked_at),
            generateLogStatus(log),
            generateLogChange(log.state),
            getRegions(log),
            generateLogDuration(log.down_duration)
        ])
    })
    return (
        data ? (
            <Table
                tableHeader={tableHeader}
                tbodyData={tbodyData}
                data={data}
                hasCheckbox={false}
                isMultiCheckable={false}
                isScrollable={data?.length > 10}
            />
        ) : <></>
    )
}

export default LogsTable
